export class Stroke {
    public fill: string;
    public strokeFill: string;
    public dashArray: number;
    public stroke_linecap: string;
    public thickness: number;
    public opacity: number;

    constructor(fill?: string, strokeFill?: string, dashArray?: number, thickness?: number, opacity?: number) {

        this.fill = fill != null ? fill : 'transparent';
        this.strokeFill = strokeFill != null ? strokeFill : 'black';
        this.dashArray = dashArray != null ? dashArray : 0;
        this.thickness = thickness != null ? thickness : 1;
        this.opacity = opacity != null ? opacity : 1;
    }
}
